import { Box } from "@chakra-ui/react";
import { Input } from "components";
import { observer } from "mobx-react";
import React, { ChangeEvent, FC, useCallback } from "react";
import { TMRIRadarNegotiatorRelationExtendedData } from "types/mri-radar.type";

const MAX_MRI_NEGOTIATOR_EMAIL_LENGTH = 255;

interface IProps {
  record: TMRIRadarNegotiatorRelationExtendedData;
  onChange: (relation: TMRIRadarNegotiatorRelationExtendedData) => void;
}

export const MRIRadarNegotiatorSyncInput: FC<IProps> = observer(
  ({ record, onChange }) => {
    const emitUsername = useCallback(
      (mriNegotiatorEmail: string) => {
        onChange({
          userAccountId: record.userAccountId,
          userName: record.userName,
          mriNegotiatorEmail,
        });
      },
      [onChange, record.userAccountId, record.userName]
    );

    const handleChange = useCallback(
      (e: ChangeEvent<HTMLInputElement>) => emitUsername(e.target.value),
      [emitUsername]
    );

    const handleBlur = useCallback(
      (e: ChangeEvent<HTMLInputElement>) => emitUsername(e.target.value.trim()),
      [emitUsername]
    );

    return (
      <Box px={1} width={"100%"}>
        <Input
          value={record.mriNegotiatorEmail ?? ""}
          placeholder={"Enter MRI login email"}
          aria-label={`MRI login email for ${record.userName}`}
          maxLength={MAX_MRI_NEGOTIATOR_EMAIL_LENGTH}
          onChange={handleChange}
          onBlur={handleBlur}
        />
      </Box>
    );
  }
);
